import React from 'react';

export default function FolderIcon({ width = 64, height = 60, fill = '#5478A1' }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 64 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.9593 6.68015C32.2157 6.68015 31.5025 6.98726 30.9767 7.53392C30.4509 8.08059 30.1556 8.82202 30.1556 9.59512V50.4047C30.1556 51.1778 30.4509 51.9192 30.9767 52.4659C31.5026 53.0126 32.2157 53.3197 32.9593 53.3197H55.3892C56.1328 53.3197 56.8459 53.0126 57.3717 52.4659C57.8975 51.9192 58.1929 51.1778 58.1929 50.4047V18.34C58.1929 17.5669 57.8975 16.8255 57.3717 16.2788C56.8459 15.7322 56.1328 15.4251 55.3892 15.4251H52.5854C51.648 15.4251 50.7726 14.938 50.2526 14.127L45.4775 6.68015H32.9593ZM21.7429 0.849609C21.7429 0.849609 30.7285 0.850209 32.9593 0.850209H46.978C47.9154 0.850209 48.7908 1.3373 49.3108 2.14824L54.086 9.59512H55.3892C57.62 9.59512 59.7594 10.5165 61.3368 12.1564C62.9142 13.7964 63.8004 16.0207 63.8004 18.34V50.4047C63.8004 52.724 62.9142 54.9483 61.3368 56.5883C59.7594 58.2283 57.62 59.1496 55.3892 59.1496H32.9593C30.7285 59.1496 28.5891 58.2283 27.0117 56.5883C25.4343 54.9483 24.5481 52.724 24.5481 50.4047V9.59512C24.5481 7.27583 20.1655 2.4896 21.7429 0.849609Z"
        fill={fill}
      />
      <path
        d="M30.9767 7.53392C31.5025 6.98726 32.2157 6.68015 32.9593 6.68015H45.4775L50.2526 14.127C50.7726 14.938 51.648 15.4251 52.5854 15.4251H55.3892C56.1328 15.4251 56.8459 15.7322 57.3717 16.2788C57.8975 16.8255 58.1929 17.5669 58.1929 18.34V50.4047C58.1929 51.1778 57.8975 51.9192 57.3717 52.4659C56.8459 53.0126 56.1328 53.3197 55.3892 53.3197H32.9593C32.2157 53.3197 31.5026 53.0126 30.9767 52.4659C30.4509 51.9192 30.1556 51.1778 30.1556 50.4047V9.59512C30.1556 8.82202 30.4509 8.08059 30.9767 7.53392Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.7394 3.41096C4.36585 1.77095 6.5718 0.849609 8.87195 0.849609H23.3265C24.2931 0.849609 25.1957 1.33671 25.7319 2.14766L30.6555 9.59461H55.1265C57.4267 9.59461 59.6326 10.516 61.259 12.156C62.8855 13.796 63.7992 16.0203 63.7992 18.3396V50.4046C63.7992 52.7239 62.8855 54.9483 61.259 56.5883C59.6326 58.2283 57.4267 59.1496 55.1265 59.1496H8.87195C6.5718 59.1496 4.36585 58.2283 2.7394 56.5883C1.11295 54.9483 0.199219 52.7239 0.199219 50.4046V9.59461C0.199219 7.27529 1.11295 5.05097 2.7394 3.41096Z"
        fill="#9CCAFF"
      />
    </svg>
  );
}
